"use client";

import {
  PillGroup,
  TextAreaField,
  TextField,
} from "@/components/tool-kit/primitives";
import type { SiftWorksheetStrings } from "@/components/tools/sift-method-worksheet";
import type { SiftField } from "@/lib/tool-kit/research-discovery/sift";

interface FieldText {
  label: string;
  hint?: string;
  placeholder?: string;
}

export function fieldText(
  strings: SiftWorksheetStrings,
  key: string
): FieldText {
  return (strings.fields as Record<string, FieldText>)[key] ?? { label: key };
}

export function optionLabel(
  strings: SiftWorksheetStrings,
  key: string,
  option: string
): string {
  const table = (strings.options as Record<string, Record<string, string>>)[
    key
  ];
  return table?.[option] ?? option;
}

/** One question of the worksheet, drawn by its kind. */
export function SiftQuestion({
  field,
  strings,
  value,
  onChange,
}: {
  field: SiftField;
  strings: SiftWorksheetStrings;
  value: string;
  onChange: (value: string) => void;
}) {
  const text = fieldText(strings, field.key);
  const id = `sift-${field.key}`;
  if (field.kind === "choice" && field.options) {
    return (
      <PillGroup
        label={text.label}
        name={id}
        onChange={onChange}
        options={field.options.map((option) => ({
          value: option,
          label: optionLabel(strings, field.key, option),
        }))}
        value={value}
      />
    );
  }
  if (field.kind === "text") {
    return (
      <TextField
        hint={text.hint}
        id={id}
        label={text.label}
        onChange={onChange}
        placeholder={text.placeholder}
        value={value}
      />
    );
  }
  return (
    <TextAreaField
      hint={text.hint}
      id={id}
      label={text.label}
      onChange={onChange}
      placeholder={text.placeholder}
      prose
      rows={3}
      value={value}
    />
  );
}
